import React from "react";
import UploadSection from "./UploadSection";
import "styles/legacy/UploadNewTitle.css";
import "./VrMediaVerification.css";

type UploadStage = "idle" | "uploading" | "uploaded" | "error";

interface Props {
  file: File | null;
  onChange: (file: File | null) => void;
  uploadStage: UploadStage;
  progress: number;
  onCancel: () => void;
  onDelete?: () => void;
  isEditingPublished?: boolean;
  /** Rendered under the upload box (e.g. VR verification + transcoding status). */
  children?: React.ReactNode;
}

const TrailerUpload: React.FC<Props> = ({
  file,
  onChange,
  uploadStage,
  progress,
  onCancel,
  onDelete,
  isEditingPublished,
  children,
}) => {
  return (
    <div className="upload-section-group">
      <UploadSection
        title="Trailer"
        description="Short excerpt of the video file"
        formats="MP4, MKV, WEBM, MOV (2GB max.)"
        onFileChange={onChange}
        currentFile={file}
        accept="video/mp4,video/x-m4v,video/*,.mkv,.webm,.mov"
        uploadStage={uploadStage}
        progress={progress}
        onCancel={onCancel}
        onDelete={onDelete}
        isEditingPublished={isEditingPublished}
      />
      {children}
    </div>
  );
};

export default TrailerUpload;
